import React from 'react';

export const BackpackAPIContext = React.createContext(null);
